<template>
	<div>
		<div v-if="!isMobile" class="side-box" :class="{bottom:sceneList.length == 1}">
			<div v-if="isShowLogo" class="logo">
				<div class="img" :style="{backgroundImage:`url(${worksDetail.logoPreview})`}"></div>
			</div>
			<div v-if="sceneData && sceneData.describe && isShowIntro" class="detail-box">
				<div class="detail">
					<div class="title"></div>
					<div class="content">{{ sceneData.describe }}</div>
				</div>
			</div>
		</div>

		<div v-if="show" class="m-intro">
			<div class="title"></div>
			<div class="content">{{ sceneData.describe }}</div>
		</div>
		<div v-if="show" class="m-intro-mask" @click="$emit('update:show',false)"></div>
	</div>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		props: {
			show: Boolean,
		},

		computed: {
			...mapState('preview', ['materialId', 'sceneList','isShowIntro','worksDetail']),
			sceneData() {
				let sceneList = this.sceneList;
				return Array.isArray(sceneList) ? sceneList.find(item => this.materialId == item.id) : {}
			},
			isShowLogo() {
				return this.worksDetail.logoPreview && this.sceneList[0] && this.materialId == this.sceneList[0].id
			}
		}

	}
</script>

<style scoped>
	.side-box {
		position: absolute;
		z-index: 100;
		left: 20px;
		top: 20px;
		bottom: 120px;
		display: flex;
		flex-direction: column;
	}

	.side-box.bottom{
		bottom: 20px;
	}

	.side-box .logo {
		width: 250px;
		height: 250px;
		background: rgba(255, 255, 255, 0.7);
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 6px;
		margin-bottom: 20px;

	}

	.side-box .logo .img {
		width: 80%;
		height: 80%;
		background-size: contain;
		background-position: center center;
		background-repeat: no-repeat;
	}

	.side-box .detail-box {
		flex: 1;
		min-height: 0;
	}

	.side-box .detail {
		width: 250px;
		border-radius: 6px;
		background: rgba(255, 255, 255, 0.75);
		max-height: 100%;
		display: flex;
		flex-direction: column;
	}

	.side-box .detail .title {
		height: 50px;
    width:50px;
    margin: 0 auto;
		flex-shrink: 0;
		background-size: auto 20px;
		border-bottom: 1px solid #ebebee;
		background: url("../../../assets/images/text-xiangqing.png?v=2023") center center no-repeat;
    background-size: contain;
	}

	.side-box .detail .content {
		padding: 15px;
		font-size: 13px;
		line-height: 1.7;
		color: #000;
		flex: 1;
		overflow-y: auto;
		text-indent: 1.5em;
		min-height: 100px;
		text-align: justify;
	}

	.m-intro-mask {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 10;
	}

	.m-intro {
		position: absolute;
		width: 80%;
		max-width: 600px;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		background: rgba(255, 255, 255, 0.8);
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		z-index: 11;
		padding: 10px;
	}

	.m-intro .title {
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		border-bottom: 2px solid #eaecef;
		background: url("../../../assets/images/text-jianjie.png") center center no-repeat;
		background-size: 36px auto;
	}

	.m-intro .content {
		padding: 10px;
		min-height: 100px;
		max-height: 500px;
		flex: 1;
		overflow-y: auto;
		text-indent: 1.5em;
		line-height: 1.8;
		font-size: 13px;
	}
</style>